import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addJobTitles,
  deleteJobTitle,
  fetchJobTitles,
  fetchPublicJobTitles,
  updateJobTitle,
} from "./JobTitlesAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobTitlesAsync = createAsyncThunk(
  "jobTitles/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobTitles();

      const resp = data.response;
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchPublicJobTitlesAsync = createAsyncThunk(
  "publicJobTitles/fetch",
  async (keyword = "", { rejectWithValue }) => {
    try {
      const data = await fetchPublicJobTitles(keyword);

      const resp = data.response;
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteJobTitleAsync = createAsyncThunk(
  "jobTitles/deleteJobTitle",
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobTitle(uuid);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobTitleAsync = createAsyncThunk(
  "jobTitles/updateJobTitle",
  async ({ uuid, title, status }, { rejectWithValue }) => {
    try {
      const response = await updateJobTitle(uuid, title, status);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobTitlesAsync = createAsyncThunk(
  "jobTitles/add",
  async (newJobTitle) => {
    try {
      const data = await addJobTitles(newJobTitle);
      return data;
    } catch (error) {
      return error;
    }
  }
);

const jobTitlesSlice = createSlice({
  name: "jobTitles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobTitlesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobTitlesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobTitlesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchPublicJobTitlesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicJobTitlesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchPublicJobTitlesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addJobTitlesAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobTitlesAsync.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateJobTitleAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobTitleAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.map((jobTitle) =>
          jobTitle.id === action.payload.id ? action.payload : jobTitle
        );
      })
      .addCase(updateJobTitleAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteJobTitleAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobTitleAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((title) => title.uuid !== action.payload);
      })
      .addCase(deleteJobTitleAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const selectJobTitles = (state) => state.jobTitles.data;

export default jobTitlesSlice.reducer;